import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context';
import { TypeUser } from '../types/enums';
import { AppVersion } from '../components/AppVersion';
import { useUserPlanStatus } from '../hooks/useUserPlanStatus';

const AuthRoute: ({ children }: { children: React.ReactNode }) => any = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { tokenIsValid, user } = useAuth();
  const location = useLocation();
  const { shouldRedirectToSubscribe } = useUserPlanStatus();

  if (!tokenIsValid) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  if (user.type === TypeUser.BASEUSER && location.pathname !== '/complementRegister') {
    return <Navigate to="/complementRegister" state={{ from: location }} replace />;
  }
  if (user.type !== TypeUser.BASEUSER && location.pathname === '/complementRegister') {
    return <Navigate to="/feed" state={{ from: location }} replace />;
  }

  if (shouldRedirectToSubscribe && location.pathname !== '/subscribe') {
    return <Navigate to="/subscribe" state={{ from: location }} replace />;
  }

  if (user.type === TypeUser.USER && location.pathname === '/legalPersonAccount')
    return <Navigate to="/naturalPersonAccount" state={{ from: location }} replace />;

  if (user.type === TypeUser.COMPANY && location.pathname === '/naturalPersonAccount')
    return <Navigate to="/legalPersonAccount" state={{ from: location }} replace />;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: 1 }}>{children}</div>
      <AppVersion />
    </div>
  );
};

export default AuthRoute;
